import {apiClient} from '@/core/api/httpClient'

export default {
  loadRealtimeReport: async (param) => {
    let filter = param.filter ? `&$filter=${param.filter}`:'';
    filter += param.type ? `&type=${param.type}`:'';

    return await apiClient.get(`${param.url}?${filter}`)
  },
}
